;(function() {
  'use strict'

  Controller.$inject = ["$q", "$timeout", "$state", "glPrefs", "websiteService", "userService", "responderService"];
  angular.module('app.survey').component('surveyOutro', {
    controller: Controller,
    templateUrl: 'survey-outro.html',
    bindings: {
      survey: '<',
      outro: '<',
      reward: '<',
      channel: '<',
    },
  })

  /* @ngInject */
  function Controller(
    $q,
    $timeout,
    $state,
    glPrefs,
    websiteService,
    userService,
    responderService
  ) {
    var ctrl = this
    var outlinkPrefs = glPrefs.create('outlink')

    ctrl.$onInit = onInit
    ctrl.restart = restart
    ctrl.rewardForm = {}
    ctrl.submitReward = submitReward
    ctrl.user = userService.loggedIn() && userService.get()
    ctrl.termsUrl = websiteService.getTermsUrl()

    function onInit() {
      var responseText =
        ctrl.outro.message || 'Thank you for taking this survey.'
      var exitText =
        "Thank you but unfortunately you don't qualify to complete this survey."
      var reward = ctrl.reward
      var didLeave =
        ctrl.survey.didExit ||
        ctrl.survey.didHitQuota ||
        ctrl.survey.didQualityExit

      if (reward) {
        ctrl.thanksText = didLeave
          ? reward.outroFeedTextExit
          : reward.outroFeedTextResponse
        ctrl.rewardSubtitle = didLeave
          ? reward.outroWinTextExit
          : reward.outroWinTextResponse
      } else {
        ctrl.thanksText = reward ? exitText : responseText
      }

      ctrl.showRestartBtn = ctrl.outro.restartButton || ctrl.survey.isReadOnly
      ctrl.showDoneBtn =
        !ctrl.showRestartBtn &&
        (ctrl.survey.isKiosk ||
          $state.params.embedded ||
          ctrl.survey.survey.submitRoute)

      function onIntercept(data, options) {
        console.log('[onIntercept]')
        // if this survey has an active outlink, lets
        // snapshot the request and redirect
        if (
          ctrl.survey.outlink &&
          ctrl.survey.outlink.enabled &&
          ctrl.survey.outlink.url &&
          !ctrl.survey.outlinkOverride &&
          data.type === 'COMPLETE'
        ) {
          var override = {
            data: data,
            options: options,
            redirects: ctrl.survey.redirects,
          }
          console.log(
            '[onIntercept] storing override for next time',
            JSON.stringify(override, null, 2)
          )
          outlinkPrefs.set('override', override)
          var url = ctrl.survey.outlink.url
          url = url.replace('{rid}', data.id)
          console.log('[onIntercept] cancel and redirect to', url)
          window.location.href = url
          return {
            cancel: true,
          }
        }
        // if we have an outlink override, lets
        // override the request
        if (ctrl.survey.outlinkOverride) {
          console.log(
            '[onIntercept] overriding data to be submitted',
            JSON.stringify(ctrl.survey.outlinkOverride, null, 2)
          )
          return {
            override: true,
            data: ctrl.survey.outlinkOverride.data,
            options: ctrl.survey.outlinkOverride.options,
          }
        }
      }

      $q.all(ctrl.survey.preSubmits).then(function() {
        responderService.submit(ctrl.survey, onIntercept).then(onSent)
      })
    }

    function onSent() {
      if (ctrl.survey.outlinkOverride) {
        console.log(
          '[onSent] clearing override!!!',
          JSON.stringify(ctrl.survey.outlinkOverride, null, 2)
        )
        outlinkPrefs.set('override', null)
      }

      var redirects = ctrl.survey.redirects

      console.log('[onSend] redirects', JSON.stringify(redirects, null, 2))

      // if the survey exited and we have an exit url - go there immediately (dont show outro)
      if (ctrl.survey.didExit && redirects.enabled && redirects.exitLink) {
        window.location.href = redirects.exitLink

        // if the survey quality exited and we have a quality exit url - go there immediately (dont show outro)
      } else if (
        ctrl.survey.didQualityExit &&
        redirects.enabled &&
        redirects.qualityExitLink
      ) {
        window.location.href = redirects.qualityExitLink

        // if the respondent hit quota and we have a quota link - go there immediately (dont show outro)
      } else if (
        ctrl.survey.didHitQuota &&
        redirects.enabled &&
        redirects.quotaLink
      ) {
        window.location.href = redirects.quotaLink

        // if the survey didnt exit or hit quota and we have a submit url - go there immediately (dont show outro)
      } else if (
        !ctrl.survey.didExit &&
        !ctrl.survey.didHitQuota &&
        !ctrl.survey.didQualityExit &&
        redirects.enabled &&
        redirects.submitLink
      ) {
        window.location.href = redirects.submitLink

        // otherwise show outro
      } else {
        ctrl.outro.isShown = true
      }

      if (ctrl.user) {
        ctrl.rewardForm.name = ctrl.user.fullname
        ctrl.rewardForm.email = ctrl.user.email
      }
    }

    function restart() {
      $state.go('app.survey', { id: ctrl.survey.survey.id }, { reload: true })
    }

    function submitReward() {
      var survey = ctrl.survey
      // var reward = ctrl.reward
      var form = ctrl.rewardForm
      var user = ctrl.user

      if (form.isSubmitting || !form.name || !form.email) {
        return
      }

      form.isSubmitting = true

      // fake it if read-only
      if (survey.isReadOnly) {
        $timeout(function() {
          form.isSubmitted = true
        }, 200)
        return
      }

      responderService
        .submitReward(survey, form.name, form.email, user.id)
        .then(function() {
          form.isSubmitted = true
        })
        .catch(function(error) {
          if (error.status === 409) {
            // TODO: the user is already registered wtf do we do now?
            console.error(
              'User tried to submit reward transaction with email that is already registered'
            )
          }
        })
    }
  }
})()
